<template>
  <div class="dashpptlist" v-if="session.pages">
    <div class="dash-left" @click="prev"></div>
    <div class="inner-swiper" ref="innerSwiper">
      <div
        v-for="(item, index) in session.pages"
        :key="index"
        :ref="currentPageIndex === index ? 'activeRef' : ''"
        :tabindex="currentPageIndex === index ? '0' : ''"
        @click="changeToPage(index, item._id)"
        class="ppt-list-item-outer">
        <div v-bind:class="currentPageIndex == index ? 'ppt_content image_parent_focus' : 'ppt_content '">
          <div
            v-if="isCpaWhiteBg(item)"
            class="image_parent cpa-thumb-white-bg">
            <div class="cpa-thumb-text" v-html="getAbstractData(item)"></div>
          </div>
          <div
            v-else
            class="image_parent"
            :style="`background-image:url(${item.default ? '/' + item.default : Fn.hashToUrl(item.default || item.pic || item.url)})`"></div>
          <i class="index-tag">{{ index + 1 }}/{{ session.pages.length }}</i>
        </div>
      </div>
    </div>
    <div class="dash-left dash-right" @click="next"></div>
  </div>
</template>
<script>
import {mapState, mapActions} from 'vuex'
export default {
  props: {
    changePage: {
      type: Function,
    },
  },
  computed: {
    ...mapState(['session']),
    ...mapState({
      currentPageIndex: (state) => state.student.currentPageIndex,
    }),
  },
  mounted() {
    this.focus()
  },
  watch: {
    currentPageIndex() {
      this.focus()
    },
  },
  methods: {
    next() {
      if (this.currentPageIndex < this.session.pages.length - 1) {
        const nextIndex = this.currentPageIndex + 1
        this.changeToPage(nextIndex, this.session.pages[nextIndex]._id)
      }
    },
    prev() {
      if (this.currentPageIndex > 0) {
        const prevIndex = this.currentPageIndex - 1
        this.changeToPage(prevIndex, this.session.pages[prevIndex]._id)
      }
    },
    changeToPage(index, page_id) {
      Acan.url('id', page_id)
      this.changePage(index + 1)
    },
    focus() {
      this.$nextTick(() => {
        if (this.$refs.activeRef && this.$refs.activeRef[0]) {
          this.moveSlow(0, this.$refs.activeRef[0].offsetLeft - this.$refs.innerSwiper.offsetWidth / 2)
        }
      })
    },
    moveSlow(distance, total) {
      this.$refs.innerSwiper.scrollLeft = distance + total
      return
      // 正向滚动 和 反向滚动
      if (this.lastItemIndex < this.itemIndex) {
        // 每隔1毫秒移动一小段距离，直到移动至目标至为止，反之亦然
        if (distance < total) {
          distance += step
          this.$refs.idSwiperImg.scrollLeft = distance
          setTimeout(() => {
            this.moveSlow(distance, total, step)
          }, 1)
        } else {
          this.$refs.idSwiperImg.scrollLeft = total
        }
      } else if (this.lastItemIndex > this.itemIndex) {
        if (distance > total) {
          distance -= step
          this.$refs.idSwiperImg.scrollLeft = distance
          setTimeout(() => {
            this.moveSlow(distance, total, step)
          }, 1)
        } else {
          this.$refs.idSwiperImg.scrollLeft = total
        }
      }
    },
    getAbstractData(item) {
      const questions = this.session?.questions || []
      const q = questions.find((o) => o.page === item._id || o._id === item._id || o.id === item._id)
      if (!q) return ''
      return q.abstractData || (q.abstract && q.abstract.data) || (q.cpa && q.cpa.abstract && q.cpa.abstract.data) || ''
    },
    hasNoPic(item) {
      return !(item && (item.pic || item.url || item.default))
    },
    isCpaWhiteBg(item) {
      return this.hasNoPic(item) && !!this.getAbstractData(item)
    },
  },
}
</script>

<style scoped>
.cpa-thumb-white-bg {
  background-color: #ffffff !important;
  display: flex !important;
  align-items: center;
  justify-content: center;
  padding: 4px 6px;
  box-sizing: border-box;
  overflow: hidden;
}
.cpa-thumb-text {
  font-size: 10px;
  line-height: 1.2;
  color: #333333;
  max-height: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  word-break: break-word;
  user-select: none;
  pointer-events: none;
}
</style>
